import api from "./api";

const route = "/whatsapp";

export default {
  sync: () => api.post(`${route}/sync`),
};
